/**
 * ApprovalPoliciesPage - Approval policy management dashboard
 *
 * Surfaces the TaskApprovalPolicyManager from @ferp/workflow-forms for admin/architect users.
 * Provides approval policy configuration, threshold management, and escalation rules.
 *
 * Route: /admin/approval-policies
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconShieldCheck } from '@tabler/icons-react';

import { TaskApprovalPolicyManager } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function ApprovalPoliciesPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="indigo">
            <IconShieldCheck size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Approval Policies</Title>
            <Text size="sm" c="dimmed">
              Approval policy configuration, thresholds, and escalation rules
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <TaskApprovalPolicyManager tenantId={tenant?.id ?? ''} />
    </Container>
  );
}

export default ApprovalPoliciesPage;
